import {AbstractLocalStorageService} from "../abstract-local-storage.service";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class RealAuthUserLocalStorageService extends AbstractLocalStorageService<number> {

  protected getDefaultValue(): number {
    return null;
  }

  protected getItemKey(): string {
    return 'real-auth-user-id';
  }
}
